import { mergeObjectTypes } from '../cacheHelpers';

const PortOfDestination = {
  merge: mergeObjectTypes
};

export default PortOfDestination;
